interface AddListButtonProps {
  icon: JSX.Element;
  text: string;
  onClickFunction: () => void;
}

const AddListButton: React.FC<AddListButtonProps> = ({
  icon,
  text,
  onClickFunction,
}) => {
  return (
    <div
      className="w-full px-2 py-3 rounded-lg border border-dashed border-neutral-300 hover:bg-neutral-25 ease-in-out duration-150 inline-flex justify-center items-center gap-2 cursor-pointer"
      onClick={onClickFunction}
    >
      {icon}
      <div className="justify-start text-neutral-500 text-base font-normal font-sans leading-tight">
        {text}
      </div>
    </div>
  );
};

export default AddListButton;
